import styled from 'styled-components'

export const Colors = styled.div`
    background: linear-gradient(
        90deg,
        rgb(255, 0, 0) 0%,
        rgb(255, 128, 0) 8%,
        rgb(255, 255, 0) 17%,
        rgb(128, 255, 0) 25%,
        rgb(0, 255, 0) 33%,
        rgb(0, 255, 128) 42%,
        rgb(0, 255, 255) 50%,
        rgb(0, 128, 255) 58%,
        rgb(0, 0, 255) 67%,
        rgb(128, 0, 255) 75%,
        rgb(255, 0, 255) 83%,
        rgb(255, 0, 128) 92%,
        rgb(255, 0, 0) 100%
    );
    border-radius: inherit;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
`
